const OFF="off";
const SLOW="slow";
const FAST="fast";
const UNKNOWN="unknown";
const TIMEOUT=1000;

export default class VueConnectionListener {
    constructor(bus) {
        
        this.connectionTimer=null;
        this.vendor=(typeof(window) === 'undefined') ? 'Unknown' : navigator.vendor;
        this.type=null;
        this.lastType=null;
        this.bus = bus;
        this.lastConnectedTime= null;
        this.lastDisconnectedTime=null;
        this.listener = () => {
            let offlineTimeInSeconds = (this.lastConnectedTime && this.lastDisconnectedTime)?((this.lastConnectedTime.getTime() - this.lastDisconnectedTime.getTime()) / 1000):new Date(8640000000000000).getTime();
            let isOnline=(this.getConnection()!=OFF) || false; //navigator.onLine || false
            console.log(`User is ${isOnline?'online':'offline'}`);
            this.bus.$emit("connection", isOnline,this.lastConnectedTime,this.lastDisconnectedTime,offlineTimeInSeconds);
        };
    }
    register() {
        this.startConnectionObserver();
    }
    unregister() {
        this.stopConnectionObserver();
    }
    checkConnection(){
        this.vendor.includes('Google') && this.type !== 'Unknown'
        ? (this.type = navigator.connection.effectiveType)
        : (this.type = 'Unknown');

        this.type=(navigator.onLine)?this.type:"offline";

        if(this.changedFromOnlineToOffline()){
            this.lastType=this.type;
            this._offlineCallback();
        }

        if(this.changedFromOfflineToOnline()){
            this.lastType=this.type;
            this._onlineCallback();
        }
    }
    getConnection(){
        return this._getConnection(this.type);
    }
    getFormerConnection(){
        return this._getConnection(this.lastType);
    }
    changedFromOnlineToOffline(){
        return this.getFormerConnection()!=OFF && this.getConnection()==OFF;
    }
    changedFromOfflineToOnline(){
        return this.getFormerConnection()==OFF && this.getConnection()!=OFF;
    }
    _offlineCallback(){
        this.lastDisconnectedTime=new Date();
        this.listener();
    }
    _onlineCallback(){
        this.lastConnectedTime= new Date();
        this.listener();
    }
    _getConnection(type){
        if(type === 'offline'){
            return OFF;
        }
        
        if(type === 'Unknown'){
            return UNKNOWN;
        }
        if(type === '2g' && type !== 'Unknown'){
            return SLOW;
        }
        if(type !== '2g' && type !== 'Unknown'){
            return FAST;
        }
    }
    startConnectionObserver(){
        this.connectionTimer=setInterval(()=>{
            this.checkConnection();
        },TIMEOUT);
    }
    stopConnectionObserver(){
        clearInterval(this.connectionTimer);
        this.connectionTimer=null;
    }
}